import { render, staticRenderFns } from "./TempManage.vue?vue&type=template&id=f85dbfd4&scoped=true&"
import script from "./TempManage.vue?vue&type=script&lang=ts&"
export * from "./TempManage.vue?vue&type=script&lang=ts&"
import style0 from "./TempManage.vue?vue&type=style&index=0&id=f85dbfd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85dbfd4",
  null
  
)

export default component.exports